function queryValue(value) {
  const candidate = Array.isArray(value) ? value[0] : value;
  return candidate == null ? "" : String(candidate);
}

export function mergeLivenessRouteQuery(to = {}, from = {}) {
  const toQuery = { ...(to.query || {}) };
  const fromQuery = Object.keys(from.query || {}).reduce((query, key) => {
    if (key !== "errorMessage") query[key] = from.query[key];
    return query;
  }, {});
  const fromVerifyId = queryValue(fromQuery.verify_id);
  const hasExplicitToVerifyId = Object.prototype.hasOwnProperty.call(
    toQuery,
    "verify_id"
  );
  const toVerifyId = queryValue(toQuery.verify_id);

  const sameExplicitSession = Boolean(
    hasExplicitToVerifyId &&
    fromVerifyId &&
    toVerifyId &&
    fromVerifyId === toVerifyId
  );
  const internalContinuation = Boolean(
    !hasExplicitToVerifyId && fromVerifyId && to.path && to.path !== "/"
  );

  // Explicit new launches are authoritative. In particular, never carry an
  // old callback into a different verify_id or a direct visit to the home page.
  return sameExplicitSession || internalContinuation
    ? { ...fromQuery, ...toQuery }
    : toQuery;
}
